import { MoreHorizontal, Pencil, Eye, EyeOff, Trash2, Copy, Share2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface EventActionsMenuProps {
  isPublished: boolean;
  isPast?: boolean;
  isToggling?: boolean;
  onEdit: () => void;
  onToggleVisibility: () => void;
  onDelete: () => void;
  onClone?: () => void;
  onShare?: () => void;
  /** When true, shows Publicera instead of Visa för kunder */
  showPublishAction?: boolean;
  isPublishable?: boolean;
}

export function EventActionsMenu({
  isPublished,
  isPast,
  isToggling,
  onEdit,
  onToggleVisibility,
  onDelete,
  onClone,
  onShare,
  showPublishAction,
  isPublishable = true,
}: EventActionsMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 shrink-0"
          onClick={(e) => e.stopPropagation()}
        >
          <MoreHorizontal className="h-4 w-4" />
          <span className="sr-only">Åtgärder</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onClick={(e) => e.stopPropagation()}>
        {isPast ? (
          <>
            <DropdownMenuItem onClick={onEdit}>
              <Eye className="h-4 w-4 mr-2" />
              Visa
            </DropdownMenuItem>
            {onClone && (
              <DropdownMenuItem onClick={onClone}>
                <Copy className="h-4 w-4 mr-2" />
                Skapa ny från denna
              </DropdownMenuItem>
            )}
          </>
        ) : (
          <>
            <DropdownMenuItem onClick={onEdit}>
              <Pencil className="h-4 w-4 mr-2" />
              Redigera
            </DropdownMenuItem>
            {onShare && (
              <DropdownMenuItem onClick={onShare}>
                <Share2 className="h-4 w-4 mr-2" />
                Dela
              </DropdownMenuItem>
            )}
            <DropdownMenuItem onClick={onToggleVisibility} disabled={isToggling || (showPublishAction && !isPublished && !isPublishable)}>
              {isPublished ? (
                <>
                  <EyeOff className="h-4 w-4 mr-2" />
                  Göm för kunder
                </>
              ) : showPublishAction ? (
                <>
                  <Eye className="h-4 w-4 mr-2" />
                  {isPublishable ? 'Publicera' : 'Komplettera först'}
                </>
              ) : (
                <>
                  <Eye className="h-4 w-4 mr-2" />
                  Visa för kunder
                </>
              )}
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              className="text-destructive focus:text-destructive"
              onClick={onDelete}
            >
              <Trash2 className="h-4 w-4 mr-2" />
              Ta bort aktivitet
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}